export const navigationItems = [
  { label: "HOME", href: "/" },
  { label: "OUR WORK", href: "/src/work.html" },
  { label: "CONNECT", href: "/src/connect.html" },
];
